<template>
  <div class="patient_content-wrapper">
    <progress-bar></progress-bar>
    <!--  MOBILE SECTION HEAD  -->
    <section-head :patient="'joseph'" v-if="this.userAgent.window.width < 1024"></section-head>
    <!--    -->

    <!--  S1  -->
    <section-wrapper
        :class="this.JosephQuizData.name + '_patient_section_1'"
        :id="1"
        :patientName="this.JosephQuizData.name">
      <template slot="section">
        <div class="section first-section">

          <h1 class="patient-title">Meet Joseph*</h1>

          <h3 class="patient-description" v-html="this.JosephData.story"></h3>

          <div class="text_container">
            <p class="text">Interested in managing his recurrent cold-like symptoms with a therapy that accommodates his travel schedule.</p>
          </div>

          <div class="title_container">
            <h2 class="section-title">History and Presenting Symptoms</h2>
          </div>

          <div class="double_container reversed">
            <div class="double_container-left">
              <div class="icon_container">
                <div class="icon-item">
                  <div class="icon-item--left">
                    <img alt class="icon-item-image" src="@/assets/img/patients/family-history-m.svg">
                  </div>
                  <div class="icon_container--right">
                    <p class="text text--icon-title">Family History:</p>
                    <p class="text text--icon-description">Brother and sister have seasonal allergies, mother has year-round allergies</p>
                  </div>
                </div>
                <div class="icon-item">
                  <div class="icon-item--left">
                    <img alt class="icon-item-image" src="@/assets/img/patients/social-history.svg">
                  </div>
                  <div class="icon_container--right">
                    <p class="text text--icon-title">Social History:</p>
                    <p class="text text--icon-description">No pets at home, rugs and carpeting in his bedroom</p>
                  </div>
                </div>
                <div class="icon-item pb-0">
                  <div class="icon-item--left">
                    <img alt class="icon-item-image" src="@/assets/img/patients/medical-history.svg">
                  </div>
                  <div class="icon_container--right">
                    <p class="text text--icon-title">Medical History</p>
                    <ul class="ul_container">
                      <li class="text li-item">10-year history of cold-like symptoms and recurring URTIs all year-round; symptoms worsen during fall and winter months, when cleaning and traveling</li>
                      <li class="text li-item">History of consistent congestion, itchy watery eyes, nasal obstruction, itchy and dry skin, symptoms may contribute to trouble sleeping</li>
                      <li class="text li-item">Home remedies and avoidance measures ineffective at providing relief from symptoms</li>
                      <li class="text li-item">Current medications include antibiotics, daily nasal corticosteroids, OTC antihistamines, and eye drops for the past 5 years with limited symptom relief</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="double_container-right">
              <div class="video_block_container">
                <div class="video_block_container">
                  <div class="video_block-content">

                    <div class="video_head">
                      <p class="video-title">EXPERT’S OPINION</p>
                    </div>
                    <div class="video_block" @click="toggleModal('modal-video')">

                      <img class="video-thumbnail" src="@/assets/img/video/thumbnail_joseph.png" alt>
                      <img class="video-playButton" src="@/assets/img/video/play_button.svg" alt>
                      <!--        VIDEO              -->

                    </div>
                    <div class="video_footer">
                      <div class="video_footer-left">
                        <img class="health-image" :src="this.JosephData.docImage" alt>
                      </div>
                      <div class="video_footer-right">
                        <p class="health-description" v-html="this.JosephData.docDesc"></p>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="footnotes_container pt-0">
            <p class="text text--footnote"><nobr>URTIs=Upper</nobr> respiratory tract infections; <nobr>OTC=Over-the-counter.</nobr></p>
          </div>

          <div class="title_container js-botTopFadeIn">
            <h2 class="section-title">Initial Examination</h2>
          </div>

          <div class="icon_container js-botTopFadeIn">
            <div class="icon-item pb-0">
              <div class="icon-item--left">
                <img alt class="icon-item-image" src="@/assets/img/patients/initial-treatment.svg">
              </div>
              <div class="icon_container--right">
                <ul class="ul_container">
                  <li class="text li-item pt-0">Upon examination, Joseph had pale and severely boggy nasal inferior turbinates, skin was dry to touch</li>
                  <li class="text li-item">Skin prick test revealed a positive reaction to grass (2+) and dust mites (3+)</li>
                  <li class="text li-item">SNOT-22 questionnaire score of 3 (moderate problem)</li>
                  <li class="text li-item">Investigation revealed significant perennial allergy</li>
                </ul>
              </div>
            </div>
          </div>

          <div class="footnotes_container pt-0 js-botTopFadeIn">
            <p class="text text--footnote"><nobr>SNOT-22=Sino-nasal</nobr> outcome test-22.</p>
          </div>

          <div class="title_container js-botTopFadeIn">
            <h2 class="section-title">Diagnosis</h2>
          </div>

          <div class="icon_container js-botTopFadeIn">
            <div class="icon-item pb-0">
              <div class="icon-item--left">
                <img alt class="icon-item-image" src="@/assets/img/patients/diagnosis.svg">
              </div>
              <div class="icon_container--right">
                <ul class="ul_container">
                  <li class="text li-item pt-0">Perennial allergic rhinitis testing positive to multiple aeroallergens which worsens during winter seasons, intermittent allergic conjunctivitis, and stable atopic dermatitis.</li>
                </ul>
              </div>
            </div>
          </div>

          <div class="footnotes_container pt-0 js-botTopFadeIn">
            <div class="text text--footnote"><nobr>AR=allergic</nobr> rhinitis.</div>
          </div>

        </div>
        <quiz :patientName="this.JosephQuizData.name" :id='1'></quiz>
      </template>
    </section-wrapper>
    <div :class="['section-divider', 'section-divider-active']"></div>

    <!--  S2  -->
    <section-wrapper
        :class="this.JosephQuizData.name + '_patient_section_2'"
        :id="2"
        :patientName="this.JosephQuizData.name">
      <template slot="section">
        <div class="section">

          <transition name="fade" mode="out-in">
            <div class="quiz_tip_block quiz_tip_block--new_design" v-if="this.JosephQuizData.question[1].answered === true" id="tip_1">
              <p class="text text--quiz-info">HDMs may be the most common trigger of allergies in the United States. In fact, HDMs are one of the most common perennial allergens, resulting in year-round symptoms in patients.<sup>1</sup></p>
              <p class="text text--footnote pt-20">HDM=house dust mite.</p>
            </div>
          </transition>

          <div class="double_container js-botTopFadeIn">
            <div class="double_container-left double">
              <img alt class="circle-svg" src="@/assets/img/patients/joseph/joseph_circle.svg"/>
              <p class="text">An estimated <span class="accent">84%</span> of US homes have detectable HDM allergen<sup>2</sup></p>
            </div>
            <div class="double_container-right double">
              <img alt class="people-svg" src="@/assets/img/patients/joseph/joseph_people.svg"/>
              <p class="text"><span class="accent">5 out of 10</span> patients with AR were reported to be sensitized to HDM allergens<sup>3</sup></p>
            </div>
          </div>

        </div>
        <quiz :patientName="this.JosephQuizData.name" :id='2'></quiz>
      </template>
    </section-wrapper>
    <div :class="['section-divider', {'section-divider-active': this.JosephQuizData.question[1].answered === true}]"></div>

    <!--  S3  -->
    <section-wrapper
        :class="this.JosephQuizData.name + '_patient_section_3'"
        :id="3"
        :patientName="this.JosephQuizData.name">
      <template slot="section">
        <div class="section">

          <transition name="fade" mode="out-in">
            <div class="quiz_tip_block quiz_tip_block--new_design" v-if="this.JosephQuizData.question[2].answered === true" id="tip_2">
              <p class="text text--quiz-info">Reports from the North American study demonstrate that a majority (76%) of the included subjects were polysensitized.<sup>4</sup> According to the Environmental Exposure Chamber Trial, the most
                predominant
                allergen sensitivities other than HDM were grass pollen (<i>timothy grass</i>) 71.8%; trees (<i>birch pollen</i>) 53.2%; and cat and dog dander (each) 49.2%.<sup>5</sup> Additionally, in the European Field Trial, the main
                co-sensitizations based
                on skin prick tests were as follows: grass pollen (<i>timothy grass and cross-reactive grasses pollen</i>) 41%; cat 41%; dog 28%; and tree (<i>birch pollen</i>) 22%.<sup>6</sup></p>
            </div>
          </transition>

          <!--   CL   -->
          <div class="graph_container js-botTopFadeIn">
            <graph-animation :data="animationsData['9']" class="desktop-anim graph--image full-graph"></graph-animation>
            <graph-animation :data="animationsData['10']" class="mobile-anim graph--image full-graph"></graph-animation>
            <scroll-graph :patient="'joseph'" :srcID="101" :left="10" class="mobile-anim screen-object-1" id="joseph-scroll-graph-1"></scroll-graph>
          </div>
          <!--        -->

          <div class="title_container js-botTopFadeIn">
            <h2 class="section-title">Initial Treatment</h2>
          </div>

          <div class="text_container pt-0 js-botTopFadeIn">
            <ul class="ul_container">
              <li class="text li-item pt-0">Control Joseph’s AR with daily nasal corticosteroids, nasal antihistamine spray, and prescription oral antihistamine</li>
              <li class="text li-item">Alleviate allergic conjunctivitis symptoms with eye drops as needed</li>
              <li class="text li-item">Apply topical steroids as needed to treat atopic dermatitis and good skin care regimen</li>
              <li class="text li-item">Educate Joseph on the importance of environmental control measures, such as dust mite covers and limiting rugs and carpeting in his home</li>
              <li class="text li-item">Develop a treatment plan that fits his busy lifestyle and treatment expectations</li>
              <li class="text li-item">Monitor his therapeutic progress by managing his prescription needs remotely and assigning follow-ups as necessary</li>
            </ul>
          </div>

          <div class="title_container js-botTopFadeIn">
            <h2 class="section-title">Follow-up</h2>
          </div>

          <div class="text_container pt-0 js-botTopFadeIn">
            <ul class="ul_container">
              <li class="text li-item pt-0">Joseph expressed a 10% improvement with symptomatic treatment changes and environmental control measures after <nobr>4 weeks</nobr></li>
              <li class="text li-item">Congestion symptoms remain consistent</li>
              <li class="text li-item">Eye drops provide significant relief</li>
              <li class="text li-item">Joseph prefers to achieve desired medical outcome with fewer medications</li>
              <li class="text li-item">Long-term treatment options were discussed to maximize therapeutic success</li>
            </ul>
          </div>

          <quote :patient="'joseph'" :blockID="1" class="js-botTopFadeIn"></quote>

          <div class="title_container pt-0 js-botTopFadeIn">
            <h2 class="section-title">Changes in Treatment</h2>
          </div>

          <div class="text_container pt-0 js-botTopFadeIn">
            <ul class="ul_container">
              <li class="text li-item pt-0">Not amenable to SCIT due to extensive travel demands for work</li>
              <li class="text li-item">SLIT-tablet was recommended as HDMs seems to be a prominent allergen</li>
              <li class="text li-item">Joseph was prescribed ODACTRA<sup>®</sup> for HDMs, which is affordable even with his high deductible plan due to manufacturer’s copay assistance card</li>
              <li class="text li-item">He was also prescribed auto-injectable epinephrine and received instruction and training on its appropriate use</li>
              <li class="text li-item pb-0">The first dose of ODACTRA<sup>®</sup> was given in the clinician’s office the following week</li>
            </ul>
          </div>

          <div class="footnotes_container pt-0 js-botTopFadeIn">
            <p class="text text--footnote"><nobr>SCIT=subcutaneous</nobr> immunotherapy; <nobr>SLIT=sublingual</nobr> immunotherapy.</p>
          </div>

          <div class="title_container js-botTopFadeIn">
            <h2 class="section-title">ODACTRA<sup>®</sup> is the first and only <nobr>FDA-approved</nobr> sublingual tablet for HDM-induced AR, with or without conjunctivitis</h2>
          </div>

          <div class="title_container pt-0 js-botTopFadeIn">
            <h2 class="section-title">Indication</h2>
          </div>

          <div class="text_container pt-0 js-botTopFadeIn">
            <ul class="ul_container">
              <li class="text li-item pt-0">ODACTRA<sup>®</sup> is an immunotherapy for HDM-induced AR, with or without conjunctivitis, confirmed by <i>in vitro</i> testing for IgE antibodies to <i>Dermatophagoides farinae</i> or <i>Dermatophagoides
                pteronyssinus</i> HDMs, or skin testing to licensed HDM allergen extracts
              </li>
              <li class="text li-item pb-0">For use in adults 18 through 65 years of age</li>
            </ul>
          </div>

          <div class="footnotes_container pt-0 js-botTopFadeIn">
            <p class="text text--footnote">IgE=immunoglobulin E.</p>
          </div>

          <div class="text_container_lb js-botTopFadeIn">
            <h2 class="lb_title">ODACTRA<sup>®</sup> may help your patients achieve allergy symptom relief</h2>
          </div>

        </div>
        <quiz :patientName="this.JosephQuizData.name" :id='3'></quiz>
      </template>
    </section-wrapper>
    <div :class="['section-divider', {'section-divider-active': this.JosephQuizData.question[2].answered === true}]"></div>

    <!--  S4  -->
    <section-wrapper
        :class="this.JosephQuizData.name + '_patient_section_4'"
        :id="4"
        :patientName="this.JosephQuizData.name">
      <template slot="section">
        <div class="section">

          <transition name="fade" mode="out-in">
            <div class="quiz_tip_block quiz_tip_block--new_design" v-if="this.JosephQuizData.question[3].answered === true" id="tip_3">
              <p class="text text--quiz-info">Published studies indicate that <nobr>SLIT-tablet</nobr> has been used extensively to treat persistent allergic rhinitis (PAR) and provides significant symptom relief and reduces the need for multiple
                <nobr>medications.<sup>6-8</sup></nobr>  <nobr> SLIT-tablet</nobr> also offers flexibility for patient lifestyle, expectations, or treatment preferences that may not be a good fit for SCIT. Adverse events with <nobr>SLIT-tablet</nobr> were generally mild to moderate and
                local.
              </p>
            </div>
          </transition>

          <div class="text_container pt-0 mobile-pb-0 js-botTopFadeIn">
            <p class="text">Statistically significant reduction in combined nasal symptom and medication usage scores occurred as early <nobr>as week 14</nobr> and continued throughout the year in polysensitized patients.<sup>6</sup></p>
          </div>

          <!--   CL   -->
          <div class="graph_container indent mobile-pt-0 screen-object-2 js-botTopFadeIn">
            <graph-animation :data="animationsData['11']" class="desktop-anim graph--image full-graph"></graph-animation>
            <!--            <graph-animation :data="animationsData['12']" class="mobile-anim graph&#45;&#45;image full-graph"></graph-animation>-->
            <scroll-graph :patient="'joseph'" :srcID="12" :isHead="true" :text="'Reduction in TCRS* over 52 weeks'" class="mobile-anim" id="joseph-scroll-graph-2"></scroll-graph>

          </div>
          <!--        -->

          <div class="footnotes_container pt-0 js-botTopFadeIn">
            <p class="text text--footnote">DMS=daily medication score; <nobr>DSS=daily</nobr> symptom score; <nobr>TCRS=total</nobr> combined rhinitis score.</p>
            <p class="text text--footnote superscript-in-text"><span class="sup">*</span>TCRS is defined as the sum of the rhinitis DSS and the rhinitis DMS.</p>
            <p class="text text--footnote">Primary end point: During the last 8 weeks of treatment, ODACTRA<sup>®</sup> with symptomatic medications produced <nobr>a 16.1%</nobr> reduction in TCRS compared with symptomatic medications alone <nobr>
              (5.71 [n=318]</nobr> vs
              <nobr>6.81 [n=388];</nobr> <nobr> 95% CI: −25.8%, −5.7%).<sup>8</sup></nobr>
            </p>
          </div>

          <div class="title_container js-botTopFadeIn">
            <h2 class="section-title">ODACTRA<sup>®</sup> significantly reduced AR symptoms and the use of AR medications<sup>6,8</sup></h2>
          </div>

          <div class="double_container with-percent js-botTopFadeIn">
            <div class="double_container-left">
              <img alt class="" src="@/assets/img/patients/joseph/reduction_1.svg"/>
            </div>
            <div class="double_container-right">
              <p class="text">ODACTRA<sup>®</sup> significantly reduced rhinitis DSS vs symptomatic medications alone
                (95% Cl: –23.8%, –3.9%; <nobr><i style="margin-right: 2px;">P</i>=.003)<sup>6,8</sup></nobr></p>
              <p class="text pt-10">AR symptoms that were measured included<sup>6</sup></p>
              <ul class="ul_container pt-5">
                <li class="text li-item">Runny nose</li>
                <li class="text li-item">Sneezing</li>
                <li class="text li-item">Blocked nose</li>
                <li class="text li-item">Itchy nose</li>
              </ul>
            </div>
          </div>
          <div class="double_container with-percent pt-40 js-botTopFadeIn">
            <div class="double_container-left">
              <img alt class="" src="@/assets/img/patients/joseph/reduction_2.svg"/>
            </div>
            <div class="double_container-right">
              <p class="text">ODACTRA<sup>®</sup> significantly reduced rhinitis DMS vs symptomatic medications alone
                (95% Cl: –34.7%, –1.3%; <nobr><i style="margin-right: 2px;">P</i>=.024)<sup>8</sup></nobr></p>
              <p class="text pt-10">AR medications that were measured included<sup>6</sup></p>
              <ul class="ul_container pt-5">
                <li class="text li-item">Oral antihistamine (desloratadine tablets, <nobr>5 mg)</nobr></li>
                <li class="text li-item">Nasal steroid (budesonide nasal spray, <nobr>64 mcg/dose)</nobr></li>
              </ul>
            </div>
          </div>

          <accordion :initialShow="true" :group="'josephGroup1'" :id="1" class="accordion pt-40 accordion-1 js-botTopFadeIn">
            <template slot="header">
              <p class="accordion_title unselectable">Study design</p>
              <img src="@/assets/img/accordion/arrow-bottom.svg" alt class="accordion-toggle unselectable">
            </template>
            <template slot="body">
              <p class="text text--footnote">A randomized, multinational, multicenter, placebo-controlled, double-blind trial was conducted for 52 weeks in patients aged 18 to
                66 years with HDM-induced AR, with or without asthma, and conjunctivitis (N=656). Mean age (years) was 32.1 + 10.6 for ODACTRA<sup>®</sup> patients and <nobr>32.2 + 10.9</nobr> for placebo patients. There were 152 patients with
                HDM-induced allergic asthma for both ODACTRA<sup>®</sup> and placebo. Mean duration of AR/conjunctivitis was 9.8 years and 10.0 years for ODACTRA<sup>®</sup> and placebo patients, respectively. Of ODACTRA<sup>®</sup> patients, 66%
                were
                polysensitized. Patients received ODACTRA<sup>®</sup> or placebo, with the efficacy assessment occurring during the last 8 weeks of treatment (October 1 through March 15) to avoid overlapping symptoms caused by pollen allergy. The
                primary
                efficacy end point was the average TCRS during the last 8 weeks of
                treatment. The TCRS was the sum of the rhinitis DSS and rhinitis DMS. The rhinitis DSS was the sum of 4 nasal symptoms (runny nose, stuffy nose, sneezing, and itchy nose) scored on a scale of 0 (none) to 3 (severe). The rhinitis DMS
                was calculated based on daily use of symptom-relieving medications for nasal symptoms.<sup>6,8</sup></p>
            </template>
          </accordion>

          <div class="image_container js-botTopFadeIn">
            <img src="@/assets/img/patients/footer_image.png" alt class="image full-image height-limit">
          </div>

          <div class="title_container js-botTopFadeIn">
            <h2 class="section-title">Set patient expectations on application site and systemic adverse events</h2>
          </div>
          <p class="text js-botTopFadeIn">Epinephrine use: As with all allergy immunotherapies, auto-injectable epinephrine is used to manage any serious adverse reactions that may occur, such as anaphylaxis, which can include trouble breathing,
            dizziness,
            nausea,
            vomiting, and diarrhea. In the clinical trials, use of epinephrine occurred at a rate <nobr>of 0.4% (5/1279)</nobr> for patients receiving ODACTRA<sup>®</sup> <nobr>vs 0.2% (3/1277)</nobr> for patients receiving placebo<sup>8,9</sup>
          </p>
          <ul class="ul_container js-botTopFadeIn">
            <li class="text li-item">AEs tended to be brief (median duration, <nobr>30-60 minutes),</nobr> occurred early (within minutes of administration during the first <nobr>1-7 days),</nobr> and were limited in recurrence (resolution within
              <2
              weeks)<sup>8</sup></li>
            <li class="text li-item">Discontinuation rates: Overall discontinuation rates due to AEs were 8.1% and 3.0% for ODACTRA<sup>®</sup> and placebo, respectively<sup>8</sup></li>
          </ul>
          <div class="footnotes_container pt-0 js-botTopFadeIn">
            <p class="text text--footnote">AE=adverse event.</p>
          </div>

          <div class="image_container pt-20 screen-object-3 js-botTopFadeIn">
            <div class="swipe-icon_container">
              <img src="@/assets/img/scrollgraph/swipe.svg" class="swipe-icon" alt>
            </div>
            <div class="scroll-table-head">
              <p class="st_head-text">Percentage of solicited adverse reactions within 28 days after initiation of treatment <br><nobr>(Field Study<sup>1,*</sup></nobr> <nobr> Safety Analysis Set)<sup>12</sup></nobr></p>
            </div>
            <div id="table-scroll_joseph" class="table-scroll">
              <div class="table-wrap">
                <table class="table-joseph main-table">
                  <tr class="table-joseph_row grey-background">
                    <td class="table-1_col-1 table-joseph_col-1 table_title-text fixed-side">Adverse Reaction</td>
                    <td colspan="2" class="table-joseph_col-2 table_title-text">Adverse Reactions<br/>of Any Intensity</td>
                    <td colspan="2" class="table-joseph_col-3 table_title-text">Adverse Reaction<br/>That Were Severe</td>
                  </tr>
                  <tr class="table-joseph_row">
                    <td class="table-1_col-1 text fixed-side"></td>
                    <td class="table-1_col-2 text"><b>ODACTRA<sup>®</sup><br/>(n=640)</b></td>
                    <td class="table-1_col-2 text"><b>Placebo<br/>(n=631)</b></td>
                    <td class="table-1_col-3 text"><b>ODACTRA<sup>®</sup><br/>(n=640)</b></td>
                    <td class="table-1_col-3 text"><b>Placebo<br/>(n=631)</b></td>
                  </tr>
                  <tr class="table-joseph_row grey-background">
                    <td class="table-1_col-1 text fixed-side">Throat irritation/tickle</td>
                    <td class="table-1_col-2 text">67.0%</td>
                    <td class="table-1_col-2 text">20.8%</td>
                    <td class="table-1_col-3 text">0.3%</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                  </tr>
                  <tr class="table-joseph_row">
                    <td class="table-1_col-1 text fixed-side">Itching in the mouth</td>
                    <td class="table-1_col-2 text">61.3%</td>
                    <td class="table-1_col-2 text">14.1%</td>
                    <td class="table-1_col-3 text">0.2%</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                  </tr>
                  <tr class="table-joseph_row grey-background">
                    <td class="table-1_col-1 text fixed-side">Itching in the ear</td>
                    <td class="table-1_col-2 text">51.7%</td>
                    <td class="table-1_col-2 text">11.7%</td>
                    <td class="table-1_col-3 text">0.3%</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                  </tr>
                  <tr class="table-joseph_row">
                    <td class="table-1_col-1 text fixed-side">Swelling of the uvula/back of <nobr>the mouth</nobr></td>
                    <td class="table-1_col-2 text">19.8%</td>
                    <td class="table-1_col-2 text">2.4%</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                  </tr>
                  <tr class="table-joseph_row grey-background">
                    <td class="table-1_col-1 text fixed-side">Swelling of the lips</td>
                    <td class="table-1_col-2 text">18.0%</td>
                    <td class="table-1_col-2 text">2.7%</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                  </tr>
                  <tr class="table-joseph_row">
                    <td class="table-1_col-1 text fixed-side">Swelling of the tongue</td>
                    <td class="table-1_col-2 text">15.8%</td>
                    <td class="table-1_col-2 text">2.1%</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                  </tr>
                  <tr class="table-joseph_row grey-background">
                    <td class="table-1_col-1 text fixed-side">Nausea</td>
                    <td class="table-1_col-2 text">14.2%</td>
                    <td class="table-1_col-2 text">7.1%</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                  </tr>
                  <tr class="table-joseph_row">
                    <td class="table-1_col-1 text fixed-side">Tongue pain</td>
                    <td class="table-1_col-2 text">14.2%</td>
                    <td class="table-1_col-2 text">3.0%</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                  </tr>
                  <tr class="table-joseph_row grey-background">
                    <td class="table-1_col-1 text fixed-side">Throat swelling</td>
                    <td class="table-1_col-2 text">13.6%</td>
                    <td class="table-1_col-2 text">2.4%</td>
                    <td class="table-1_col-3 text">0.2%</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                  </tr>
                  <tr class="table-joseph_row">
                    <td class="table-1_col-1 text fixed-side">Tongue ulcer/sore on the tongue</td>
                    <td class="table-1_col-2 text">11.6%</td>
                    <td class="table-1_col-2 text">2.1%</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                  </tr>
                  <tr class="table-joseph_row grey-background">
                    <td class="table-1_col-1 text fixed-side">Stomach pain</td>
                    <td class="table-1_col-2 text">11.3%</td>
                    <td class="table-1_col-2 text">5.2%</td>
                    <td class="table-1_col-3 text">0.2%</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                  </tr>
                  <tr class="table-joseph_row">
                    <td class="table-1_col-1 text fixed-side">Mouth ulcer/sore int mouth</td>
                    <td class="table-1_col-2 text">10.3%</td>
                    <td class="table-1_col-2 text">2.9%</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                  </tr>
                  <tr class="table-joseph_row grey-background">
                    <td class="table-1_col-1 text fixed-side">Taste alteration/food tasted different</td>
                    <td class="table-1_col-2 text">10.0%</td>
                    <td class="table-1_col-2 text">3.6%</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                  </tr>
                  <tr class="table-joseph_row">
                    <td class="table-1_col-1 text fixed-side">Diarrhea</td>
                    <td class="table-1_col-2 text">6.9%</td>
                    <td class="table-1_col-2 text">3.6%</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                  </tr>
                  <tr class="table-joseph_row grey-background">
                    <td class="table-1_col-1 text fixed-side">Vomiting</td>
                    <td class="table-1_col-2 text">2.5%</td>
                    <td class="table-1_col-2 text">1.4%</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                    <td class="table-1_col-3 text">&mdash;</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <div class="footnotes_container pt-0 js-botTopFadeIn">
            <p class="text text--footnote">*North American Field Efficacy Study.</p>
          </div>

          <div class="text_container js-botTopFadeIn">
            <ul class="ul_container">
              <li class="text li-item">Compliance, epinephrine protocol/counselling, and any side effects were assessed at 4 weeks posttreatment</li>
              <li class="text li-item">Joseph tolerated ODACTRA<sup>®</sup> well with initial mild oral itching, which has gradually improved and demonstrated significant improvement in symptoms at 16 weeks; SNOT-22 score decreased to 2 (mild)</li>
              <li class="text li-item">Symptoms significantly improved at <nobr>24 weeks</nobr></li>
              <li class="text li-item">Administration of nasal spray and oral antihistamine medication has been reduced to a point where he is comfortable</li>
              <li class="text li-item">Joseph is less hesitant to travel for work and spending nights in hotels</li>
            </ul>
          </div>

          <quote :patient="'joseph'" :blockID="2" class="js-botTopFadeIn"></quote>

        </div>
        <quiz :patientName="this.JosephQuizData.name" :id='4'></quiz>
      </template>
    </section-wrapper>
    <div :class="['section-divider', {'section-divider-active': this.JosephQuizData.question[3].answered === true}]"></div>

    <!--  S5  -->
    <section-wrapper
        :class="this.JosephQuizData.name + '_patient_section_5'"
        :id="5"
        :patientName="this.JosephQuizData.name">
      <template slot="section">
        <div class="section">

          <transition name="fade" mode="out-in">
            <div class="quiz_tip_block quiz_tip_block--new_design" v-if="this.JosephQuizData.question[4].answered === true" id="tip_4">
              <p class="text text--quiz-info">SLIT-tablets demonstrate efficacy in 3 separate studies in both mono- and polysensitized patients.<sup>4-6</sup></p>
            </div>
          </transition>

          <div class="title_container pt-0 js-botTopFadeIn">
            <p class="text">Data from the Environmental Exposure Chamber trial demonstrate <nobr>48.6% and 67.9%</nobr> improvement in TNSS and TOSS, respectively at week 24 in patients treated with ODACTRA<sup>®</sup>.<sup>5,8</sup></p>
          </div>

          <div class="double_container with-tabs js-botTopFadeIn">
            <div class="double_container-left">
              <patient-tabs :tabData="this.tabDataJoseph[1]"></patient-tabs>
            </div>
            <div class="double_container-right" :class="{'isIE' : this.isIE}">
              <patient-tabs :tabData="this.tabDataJoseph[2]"></patient-tabs>
            </div>
          </div>

          <div class="footnotes_container js-botTopFadeIn">
            <p class="text text--footnote"><nobr>IgG4=immunoglobulin</nobr> G <nobr>subclass 4;</nobr> <nobr>TNSS=total</nobr> nasal symptom score; <nobr>TOSS=total</nobr> ocular symptom score.</p>
            <p class="text text--footnote superscript-in-text"><span class="sup">*</span>TNSS is defined as a total score comprising the following: rhinorrhea, nasal congestion, nasal itching, and sneezing.<br/>
              IgG4 levels increased with ODACTRA<sup>®</sup> vs placebo at week 8 based on the prespecified analyses (<i class="mr-1">P</i><.001).<sup>8</sup></p>
          </div>

          <div class="text_container pt-40 js-botTopFadeIn">
            <accordion :initialShow="true" :group="'josephGroup2'" :id="1" class="accordion accordion-2">
              <template slot="header">
                <p class="accordion_title unselectable">Study design</p>
                <img src="@/assets/img/accordion/arrow-bottom.svg" alt class="accordion-toggle unselectable">
              </template>
              <template slot="body">
                <p class="text text--footnote">A randomized, single-site, placebo-controlled, double-blind, onset-of-action trial was conducted for 24 weeks in adults aged ≥18 years with HDM-induced AR/conjunctivitis, with or without asthma (N=83;
                  ODACTRA<sup>®</sup>=42, placebo=41), using the Vienna Challenge Chamber. Mean age (years/range) was 28 (18-58) for the ODACTRA<sup>®</sup> patients and 27 (19-43) for placebo patients. Mean duration of AR/conjunctivitis was 16
                  years
                  and
                  17 years for ODACTRA<sup>®</sup> and placebo patients, respectively. Of ODACTRA<sup>®</sup> patients, 88% were polysensitized. Patients received ODACTRA<sup>®</sup> or placebo and symptoms were scored every 15 minutes during
                  exposure
                  challenges, which occurred at screening and at weeks 8, 16, and 24. The primary efficacy end point was the average TNSS at week 24, which was the sum of the 4 nasal symptoms (runny nose, blocked nose, sneezing, and itchy nose),
                  with
                  a
                  maximum score of 12. A key secondary end point was the average TOSS at weeks 8, 16, and 24. The TOSS was the sum of the 2 ocular symptoms (gritty/red/itchy eyes and watery eyes). There were 10 patients and 9 patients with asthma
                  (ODACTRA<sup>®</sup> and placebo, respectively).<sup>5</sup></p>
              </template>
            </accordion>
          </div>

        </div>
        <quiz :patientName="this.JosephQuizData.name" :id='5'></quiz>
      </template>
    </section-wrapper>
    <div :class="['section-divider', {'section-divider-active': this.JosephQuizData.question[4].answered === true}]"></div>

    <!--  S6  -->
    <section-wrapper
        :class="this.JosephQuizData.name + '_patient_section_6'"
        :id="6"
        :patientName="this.JosephQuizData.name">
      <template slot="section">
        <div class="section last-section" :class="{'isiStateMin' : this.isiState === 2}">

          <transition name="fade" mode="out-in">
            <div class="quiz_tip_block quiz_tip_block--new_design" v-if="this.JosephQuizData.question[5].answered === true" id="tip_5">
              <p class="text text--quiz-info">ODACTRA<sup>®</sup> has proven efficacy in mono- and polysensitized patients throughout the year.<sup>4-6</sup> ODACTRA<sup>®</sup> is made affordable for patients with a high deductible plan, with
                manufacturer’s assistance co-pay. ODACTRA<sup>®</sup> treats the underlying cause of HDM allergy and not simply the symptoms.<sup>7,8</sup> ODACTRA<sup>®</sup> provides convenience of administration for patients who travel
                extensively.
              </p>
            </div>
          </transition>

          <div class="title_container pt-0 js-botTopFadeIn">
            <h2 class="section-title">Summary</h2>
          </div>

          <div class="text_container pb-0 pt-0 js-botTopFadeIn">
            <ul class="ul_container">
              <li class="text li-item">10-year history of allergy-related symptoms and recurring URTIs all year-round; symptoms worsen during fall and winter months, when cleaning and traveling</li>
              <li class="text li-item">History of consistent congestion, itchy watery eyes, nasal obstruction, itchy and dry skin, trouble sleeping</li>
              <li class="text li-item">Joseph initiated AIT and preferred <nobr>SLIT-tablets</nobr> for convenience and to achieve desired medical outcome with fewer medications</li>
              <li class="text li-item">Joseph was an appropriate patient for ODACTRA<sup>®</sup> for the following reasons:
                <ul class="ul_sub_container">
                  <li class="text li-sub_item">A positive skin prick test for HDMs and other environmental allergens</li>
                  <li class="text li-sub_item">Symptoms suggest a perennial and indoor element</li>
                  <li class="text li-sub_item">Convenience of administration due to extensive travel</li>
                </ul>
              </li>
            </ul>
          </div>

          <div class="footnotes_container pt-0 pb-20 js-botTopFadeIn">
            <p class="text text--footnote">AIT=allergy Immunotherapy.</p>
          </div>

          <div class="text_container js-botTopFadeIn">
            <h2 class="section-title">One tablet, once a day, for unique dosing flexibility</h2>
          </div>

          <div class="text_container pt-0 js-botTopFadeIn">
            <p class="text">Refer patients to Administration Instructions under “Patient Counseling Information” in the ODACTRA<sup>®</sup> Prescribing Information.</p>
          </div>

          <div class="fr_container js-botTopFadeIn">
            <div class="fr-content">
              <div class="fr-column fr-column--1">
                <img src="@/assets/img/patients/orange-people.svg" class="fr-image" alt>
                <p class="text text--fr">Administer first dose in a health care setting under the supervision of a medical professional<sup>8</sup></p>
              </div>
              <div class="h-divider">
                <span class="divider"></span>
              </div>
              <div class="fr-column fr-column--2">
                <img src="@/assets/img/patients/orange-clock.svg" class="fr-image" alt>
                <p class="text text--fr">Observe the patient for at least <nobr>30 minutes</nobr> to monitor for signs or symptoms of a severe systemic or local allergic reaction<sup>8</sup></p>
              </div>
              <div class="h-divider">
                <span class="divider"></span>
              </div>
              <div class="fr-column fr-column--3">
                <img src="@/assets/img/patients/orange-house.svg" class="fr-image" alt>
                <p class="text text--fr">If patient tolerates the first dose, subsequent doses may be taken at home<sup>8,*</sup></p>
              </div>
              <div class="h-divider">
                <span class="divider"></span>
              </div>
              <div class="fr-column fr-column--4">
                <img src="@/assets/img/patients/orange-point.svg" class="fr-image" alt>
                <p class="text text--fr">Practice parameters recommend that patients receiving AIT for HDM allergens be treated for 3 to 5 years to obtain maximum benefits<sup>2</sup></p>
              </div>
            </div>
          </div>

          <div class="footnotes_container js-botTopFadeIn">
            <p class="text text--footnote superscript-in-text"><span class="ml-3 sup">*</span>Data regarding the safety of restarting treatment after missing a dose of ODACTRA are limited. If a missed dose occurs, it is recommended that the next
              dose be taken at the normally scheduled time. If more than one dose is missed, patients should contact their physician to discuss re-initiation. In clinical trials, treatment interruptions for up to 7 days were allowed.<sup>8</sup>
            </p>
          </div>

          <div class="text_container pt-60 js-botTopFadeIn">
            <h2 class="global-title">ALK Support Program</h2>
          </div>

          <div class="text_container js-botTopFadeIn">
            <h2 class="section-title">Eligible patients may pay as little as $25. CLICK TO FIND OUT MORE.</h2>
          </div>

          <div class="image_container js-botTopFadeIn">
            <a href="https://www.alksavings.com/" target="_blank">
              <img src="@/assets/img/patients/susan/ALKSupportProgram.png" alt class="image">
            </a>
          </div>

          <div class="footnotes_container pt-0 js-botTopFadeIn">
            <p class="text text--footnote">Not all patients will qualify for the manufacturer’s copay assistance card, please see <a :href="this.urls.ALK" target="_blank" class="text-accent">www.ALKsavings.com</a> for terms and conditions.</p>
          </div>

          <quote :patient="'joseph'" :blockID="3" class="js-botTopFadeIn"></quote>

          <footer-buttons class="js-botTopFadeIn"></footer-buttons>

          <div class="footnotes_container pt-0 js-botTopFadeIn">
            <p class="text text--footnote">Patients should read all of the instructions for use provided under the patient information section in the Full Prescribing Information before using ODACTRA<sup>®</sup> for the first time.</p>
          </div>

          <div class="text_container pt-40 js-botTopFadeIn">
            <accordion :initialShow="false" :group="'josephGroup4'" :id="1" class="accordion accordion-4">
              <template slot="header">
                <p class="accordion_title unselectable">References</p>
                <img src="@/assets/img/accordion/arrow-bottom.svg" alt class="accordion-toggle unselectable">
              </template>
              <template slot="body">

                <p class="block-black-title pb-0">References</p>
                <ul class="ul_container number-ul">
                  <li class="text li-item">Asthma and Allergy Foundation of America. Dust mite allergy. http://www.aafa.org/page/dust-mite-allergy.aspx. Accessed July 13, 2020.</li>
                  <li class="text li-item">Portnoy J, Miller JD, Williams PB, et al; Joint Taskforce on Practice Parameters; Practice Parameter Workgroup. Environmental assessment and exposure control of dust mites: practice parameter.
                    <i>Ann Allergy Asthma Immunol</i>. 2013; 111(6):465-507.
                  </li>
                  <li class="text li-item">Bauchau V, Durham SR. Prevalence and rate of diagnosis of allergic rhinitis in Europe. <i>Eur Respir J</i>. 2004;24(5):758-764.</li>
                  <li class="text li-item">Nolte H, Bernstein DI, Nelson HS, et al. Efficacy of house dust mite sublingual immunotherapy tablet in North American adolescents and adults in a randomized, placebo-controlled trial. <i>J Allergy Clin
                    Immunol</i>. 2016;138(6):1631-1638.
                  </li>
                  <li class="text li-item">Nolte H, Maloney J, Nelson HS, et al. Onset of dose-related efficacy of house dust mites sublingual immunotherapy tablets in an environmental exposure chamber. <i>J Allergy Clin Immunol.</i>
                    2015;135(6):1494-1501.e6.
                  </li>
                  <li class="text li-item">Demoly P, Emminger W, Rehm D, et al. Effective treatment of house dust mite-induced allergic rhinitis with 2 doses of the SQ HDM SLIT-tablet: results from a randomized, double-blind, placebo-controlled
                    phase
                    III trial. <i>J Allergy Clin Immunol.</i>. 2016;137(2):444-451.
                  </li>
                  <li class="text li-item">Data on file. Merck Sharp & Dohme Corp. Whitehouse Station, NJ: 2017.</li>
                  <li class="text li-item">ODACTRA [Prescribing Information]. Hørsholm, Denmark: ALK; 2017.</li>
                  <li class="text li-item">American College of Allergy, Asthma, and Immunology. Anaphylaxis. http://www.acaai.org/allergies/anaphylaxis. Accessed July 13, 2020.</li>
                </ul>

              </template>
            </accordion>
          </div>

          <Footer class="js-botTopFadeIn"></Footer>
        </div>
      </template>
    </section-wrapper>
    <div :class="['section-divider', {'section-divider-active': this.JosephQuizData.question[5].answered === true}]"></div>

  </div>
</template>

<script>
import PatientBase from '../patients/patient_base';
import { mapState } from 'vuex';

export default {
  name: 'Joseph',
  extends: PatientBase,
  computed: {
    ...mapState(['userAgent', 'tabDataJoseph']),
    ...mapState({
      JosephQuizData: state => state.quizData.patients.joseph,
      JosephData: state => state.patients.joseph
    }),
  },
  mounted() {
  },
  updated() {
    if (document.querySelector('#table-scroll_joseph .main-table')
        && !document.querySelector('#table-scroll_joseph .main-table.table-clone')
        && document.querySelectorAll('.table-joseph.main-table.table-clone').length <= 1) {
      let cloneTable = document.querySelector('#table-scroll_joseph .main-table').cloneNode(true);
      cloneTable.classList.add('table-clone');
      document.getElementById('table-scroll_joseph').appendChild(cloneTable);
      document.querySelectorAll('.table-joseph.main-table')[0].classList.add('default-table');
    }
  }
};
</script>

<style lang="scss"></style>
